import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CereriComponent } from './cereri.component';
import { MaterialModule } from 'src/app/material.module';
import { DataTablesModule } from 'angular-datatables';
import { CereriDetaliiComponent } from './cereri-detalii/cereri-detalii.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CereriIstoricComponent } from './cereri-istoric/cereri-istoric.component';
import { ActiuniCerereCardModule } from 'src/app/shared/actiuni-cerere-card/actiuni-cerere-card.module';
import { SubsemnatModule } from 'src/app/shared/subsemnat/subsemnat.module';
import { ActualizareCerereComponent } from './cereri-detalii/actualizare-cerere/actualizare-cerere.component';
import { CereriAsigneazaComponent } from './cereri-asigneaza/cereri-asigneaza.component';
import { CereriStatusComponent } from './cereri-status/cereri-status.component';
import { ModalInchidereLucrareComponent } from './cereri-detalii/modal-inchidere-lucrare/modal-inchidere-lucrare.component';
import { SabloaneComponent } from './cereri-detalii/sabloane/sabloane.component';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { AddCerereComponent } from './add-cerere/add-cerere.component';
import { CereriPrioritateComponent } from './cereri-prioritate/cereri-prioritate.component';
import { DocumentUatComponent } from './cereri-detalii/document-uat/document-uat.component';
import { DocumenteGenerateComponent } from './cereri-detalii/documente-generate/documente-generate.component';
import { ViewMatricoleComponent } from './cereri-detalii/documente-generate/view-matricole/view-matricole.component';
import { ViewMatricoleCfComponent } from './cereri-detalii/documente-generate/view-matricole-cf/view-matricole-cf.component';
import { EditDialogComponent } from './cereri-detalii/edit-dialog/edit-dialog.component';
import { InchidereMultiplaComponent } from './inchidere-multipla/inchidere-multipla.component';

@NgModule({
    declarations: [
        CereriComponent,
        CereriDetaliiComponent,
        CereriIstoricComponent,
        ActualizareCerereComponent,
        CereriAsigneazaComponent,
        CereriStatusComponent,
        ModalInchidereLucrareComponent,
        SabloaneComponent,
        AddCerereComponent,
        CereriPrioritateComponent,
        DocumentUatComponent,
        DocumenteGenerateComponent,
        ViewMatricoleComponent,
        ViewMatricoleCfComponent,
        EditDialogComponent,
        InchidereMultiplaComponent,
    ],
    imports: [
        ActiuniCerereCardModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        DataTablesModule,
        SubsemnatModule,
        PipesModule,
    ],
    exports: [CereriComponent],
})
export class CereriModule { }
